import { CreateOrganizationModal } from '@/modules/global/components/organization/create-modal'

export const ManagerFooterHome = () => {
  return <CreateOrganizationModal />
}